import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryPayment} from "@/service/payment.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {checkQueryKey, formatTime, getRealId, getSellerNames} from "@/helper/method";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";
import {FileTable} from "@/widget/CommonDetail/FileTable";

interface ViewPaymentProps {
    mode: ModeType
}

export const ViewPayment: FC<ViewPaymentProps> = ({mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const id: number = getRealId(mode, drawerId, dialogId);
    const {data: paymentData, isLoading: paymentLoading} = useQueryPayment({id}, checkQueryKey(id))
    const payment = paymentData?.data
    console.log(drawerId, 'dddddddddd', mode)
    return <><ResultWrapper isLoading={paymentLoading} isEmpty={isEmpty(payment)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid spacing={3} container>
                <GridItem title={'专利名称'} content={payment?.patentName}/>
                <GridItem title={'申请号/专利号'} content={payment?.applyNo}/>
                <GridItem title={'客户名称'} content={payment?.customerName}/>
                <GridItem title={'业务人员'} content={getSellerNames(payment?.creator, payment?.seller)}/>
                <GridItem title={'缴费类型'} content={payment?.feeType}/>
                <GridItem title={'缴费金额'} content={payment?.amount}/>
                <GridItem title={'缴费期限'} content={formatTime("D", payment?.deadline)}/>
                <GridItem title={'服务费'} content={payment?.serviceCharge}/>
                <GridItem title={'到账方式'} content={payment?.receivingMethod}/>
                <GridItem title={'收款时间'} content={formatTime('D', payment?.arrivalTime)}/>
                <GridItem minHeight={'48px'} size={12} title={'备注'} content={payment?.remark || '-'}/>
                <FileTable checkboxSelection={false} actionable={false} tag={8} targetId={id}/>
                <GridItem title={'更新时间'} content={formatTime('D', payment?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', payment?.createdAt)}/>
            </Grid>
        </Stack>
    </ResultWrapper>
    </>
}